/**
 * CodeMirror 6-based JSON editor with syntax highlighting, line numbers,
 * bracket matching, code folding, and inline JSON parse markers.
 *
 * Pure controlled component — accepts `value` + `onChange` like the
 * native `<textarea>` it replaces in `ModuleSettingEditor`. The
 * surrounding wrapper sets `height: '100%'` and the wrap div uses
 * `flex: 1` so the editor stretches to fill the Pane content area
 * (replaces the old `minHeight: 30rem` fixed-height textarea).
 *
 * `extensions` keeps the JSON language pack only — no plain-text mode,
 * no autocomplete (admins edit a small config, suggestions would only
 * add noise). `basicSetup` covers line numbers, history, foldable
 * gutter, bracket matching, indent unit = 2.
 *
 * @uiw/react-codemirror handles the imperative state-vs-controlled
 * drift internally: when the parent changes `value` from outside (e.g.
 * a `seedTextOverride` after raw→visual round-trip) the editor resets
 * its internal doc; when the user types, `onChange` fires with the new
 * doc string. We never write back into `value` directly.
 */
import React from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { json, jsonParseLinter } from '@codemirror/lang-json';
import { linter, lintGutter } from '@codemirror/lint';
var JsonCodeEditor = function (_a) {
    var value = _a.value, onChange = _a.onChange, testId = _a.testId, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b;
    return (React.createElement("div", { "data-testid": testId, style: {
            flex: 1,
            minHeight: 0, // allow the flex item to shrink below its content size
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid #ccc',
            borderRadius: '4px',
            overflow: 'hidden',
        } },
        React.createElement(CodeMirror, { value: value, onChange: onChange, height: "100%", style: { flex: 1, fontSize: '0.875rem' }, extensions: [
                json(),
                // Surface parse errors as red squigglies in the gutter +
                // hover tooltip. Cheap (no JSON-Schema needed); the live
                // backend validator still owns the structural rules.
                linter(jsonParseLinter()),
                lintGutter(),
            ], basicSetup: {
                lineNumbers: true,
                highlightActiveLine: true,
                highlightActiveLineGutter: true,
                foldGutter: true,
                bracketMatching: true,
                closeBrackets: true,
                indentOnInput: true,
                autocompletion: false,
                tabSize: 2,
            }, readOnly: readOnly })));
};
export default JsonCodeEditor;
